/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Score } from './score';

export type GradingScoresAnyOf = { [key: string]: Score };
